if ('app' in window) {
    window.app = {
        _app: window.app,
        init: function () {
            window[this.NAME] = this;
            window.app = this._app;
            
            delete this._app;
        }
    };
} else {
    window.app = {
        init: function () {
            window[this.NAME] = this;
            
            delete window.app;
        }
    };
}

window.app.NAME = 'Jobsgopublic';

(function (window, $, Argument, app) {
    var parseFloat = window.parseFloat;

    app.modules = {};

    app.supports = function (feature) {
        return window.Modernizr[feature];
    };

    app.rejects = function (feature) {
        return ! window.Modernizr[feature];
    };

    app.exec = function (name) {
        app.ActionResolver.exec.apply(app.ActionResolver, arguments);
    };

    app.registerAction = function (name, action) {
        app.ActionResolver.registerAction(name, action);
    };

    app.registerModule = function (name, module) {
        app[name] = app.modules[name] = module;
    };

    app.bind = function () {
        /**
         * Bind any modules that require it.
         */
        for (var moduleName in app.modules) {
            if (app.modules.hasOwnProperty(moduleName) && app.modules[moduleName].hasOwnProperty('bind') && typeof app.modules[moduleName].bind == 'function') {
                app.modules[moduleName].bind();
            }
        }
        
        app.registerAction('show', function (id) {
            $('#' + id).slideDown(app.ANIMATION_DURATION * .75).fadeTo(app.ANIMATION_DURATION * .75, 1);
        });
        
        app.registerAction('hide', function (id) {
            $('#' + id).fadeTo(app.ANIMATION_DURATION * .75, 0).slideUp(app.ANIMATION_DURATION * .75);
        });
        
        app.registerAction('toggle', function (id) {
            var $el = $('#' + id);
            
            if ($el.css('display') === 'none') {
                $el.slideDown(app.ANIMATION_DURATION * .75).fadeTo(app.ANIMATION_DURATION * .75, 1);
            } else {
                $el.fadeTo(app.ANIMATION_DURATION * .75, 0).slideUp(app.ANIMATION_DURATION * .75);
            }
        });
        
        app.$doc.ready(function () {
            var Modernizr = window.Modernizr;
            
            // Throw Modernizr console warnings
            for (var prop in Modernizr) {
                if (Modernizr.hasOwnProperty(prop)) {
                    if (Modernizr[prop] === false) {
                        window.console.warn('Your browser does not support "' + prop + '", please consider upgrading to a modern browser like Google Chrome <https://www.google.com/chrome/>');
                    }
                }
            }
            
            // Forms
            $('.form').on('classAdd', function (e, changed) {
                if (changed.indexOf('frm_loading_form') >= 0) {
                    $(this).addClass('form-submitting');
                }
            }).on('classRemove', function (e, changed) {
                console.log(changed);
                
                if (changed.indexOf('frm_loading_form') >= 0) {
                    $(this).removeClass('form-submitting');
                }
            });
            
            $('select[data-select]').select2({
                allowClear: true,
                closeOnSelect: false,
                placeholder: 'pick from a list…',
            });

            // Map
            $("#map-image").mapster({
                fillColor: "FFB300",
                fillOpacity: 0.25,
                clickNavigate: true
            });
              
            var mapResizeTime = 100;
            var mapResizeDelay = 0;

            function mapResize(maxWidth, maxHeight) {
                var $image = $('#map-image'),
                    imgWidth = $image.width(),
                    imgHeight = $image.height(),
                    newWidth = 0,
                    newHeight = 0;

                if (imgWidth / maxWidth > imgHeight / maxHeight) {
                    newWidth = maxWidth;
                } else {
                    newHeight = maxHeight;
                }

                $image.mapster('resize', newWidth, newHeight, mapResizeTime);
            }

            function mapOnWindowResize() {
                var curWidth = $('#map-image').parents('.col-sm-5').width(),
                    curHeight = $('#map-image').parents('.col-sm-5').height(),
                    checking = false;
                
                if (checking) {
                    return;
                }
                
                checking = true;
                
                window.setTimeout(function () {
                    var newWidth = $('#map-image').parents('.col-sm-5').width(),
                        newHeight = $('#map-image').parents('.col-sm-5').height();

                    if (newWidth === curWidth && newHeight === curHeight) {
                        mapResize(newWidth, newHeight);
                    }

                    checking = false;
                }, mapResizeDelay);
            }

            // IE11 fix
            $(window).bind('resize', mapOnWindowResize);
            $(window).bind('resize', mapOnWindowResize);

            // Slick
            $(".carousel").slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 1500,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
                        
            /**
             * Ripple animation
             */
            if (app.supports('cssanimations') && app.supports('csstransforms')) {
                $('body').on('click', '.\\+ripple, .btn\\.content', function (e) {
                    var $this = $(this);
                    var $target = $(e.target);
                    
                    if ($target.is('.\\+clickable')) {
                        $target = $target.parent();
                    }
                    
                    if (! $this.is($target) && $target.is('.\\+ripple, .btn\\.content')) {
                        return;
                    }
                    
                    var div = window.document.createElement('div'),
                        $div = $(div),
                        $ripples = $this.find('.\\+ripple\\.animation'),
                        btnOffset = $this.offset(),
                        width = $this.width(),
                        height = $this.height(),
                        size = width > height ? height : width,
                        xPos = e.pageX - btnOffset.left,
                        yPos = e.pageY - btnOffset.top;
                    
                    // No more than 3 ripple animations in any rippled element
                    if ($ripples.length > 2) {
                        $ripples.filter(':lt(' + ($ripples.length - 2) + ')').remove();
                    }
                    
                    $div.addClass('+ripple.animation').css({
                        width: size,
                        height: size,
                        top: yPos - (size / 2),
                        left: xPos - (size / 2),
                        background: $this.data('rippleColor')
                    }).appendTo($this).on(app.animationEvent(), function () {
                        $div.remove();
                    });
                });
            }
        });
    };
})(window, jQuery, Argument, app);
